<template>
  <ym-tag class="video-program-tag"
          type="primary"
          size="small"
          plain
  >
    {{ text }}
  </ym-tag>
</template>

<script>
  import { Tag } from '@ymba/ym-ui';

  export default {
    name: 'VideoProgramTag',
    components: {
      'ym-tag': Tag,
    },
    props: {
      text: {
        type: String,
        default: '视频课',
      },
    },
  };
</script>
